import { render, staticRenderFns } from "./ModelChoice.vue?vue&type=template&id=55604d38&scoped=true&"
import script from "./ModelChoice.vue?vue&type=script&lang=js&"
export * from "./ModelChoice.vue?vue&type=script&lang=js&"
import style0 from "./ModelChoice.vue?vue&type=style&index=0&id=55604d38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55604d38",
  null
  
)

export default component.exports